<template>
  <div class="basicsInfo" v-loading.fullscreen.lock="sonLoading">
    <div class="info-center">
      <div class="kyc-icon"></div>
      <div class="title"> {{ $t('kycFile.basicsInfo.tit') }} </div>
      <lls-form
        :model="enterpriseInfo"
        :inline="true"
        label-position="top"
        :rules="rules"
        ref="ruleForm"
      >
        <p class="sub-title">
         {{ $t('kycFile.basicsInfo.blodTip') }}
        </p>
        <div class="bg-item">
        <lls-form-item :label="$t('kycFile.basicsInfo.regCountry')" prop="registeredAreaCode">
          <lls-select
            v-model="enterpriseInfo.registeredAreaCode"
            filterable
            clearable
            @change="changeRegArea"
            :placeholder="$t('common.selectPlaceholder')"
          >
            <lls-option
              v-for="item in countryList"
              :key="item.id"
              :label="item.countryName"
              :value="item.countryCode"
            ></lls-option>
          </lls-select>
        </lls-form-item>
        <template v-if="showIndustryAndSize">
          <lls-form-item
            :label="$t('kycFile.basicsInfo.province')"
            prop="provinceCode"
            :rules="isChinaAddrRequired ? [{ required:true,message:$t('kycFile.basicsInfo.province'),trigger:['blur','change'] }]: [{}]"
          >
            <lls-select
              v-model="enterpriseInfo.provinceCode"
              filterable
              clearable
              :placeholder="$t('common.selectPlaceholder')"
              @change="onRegisteredProvinceChange"
            >
              <lls-option
                v-for="item in filteredRegisteredProvinceOptions"
                :key="item.code"
                :label="$i18n.locale === 'en' ? item.displayNameEn : item.displayName"
                :value="item.code"
              ></lls-option>
            </lls-select>
          </lls-form-item>
          <lls-form-item
            :label="$t('kycFile.basicsInfo.city')"
            prop="cityCode"
            :rules="isChinaAddrRequired ? [{ required:true,message:$t('kycFile.basicsInfo.city'),trigger:['blur','change'] }]: [{}]"
          >
            <lls-select
              v-model="enterpriseInfo.cityCode"
              filterable
              clearable
              :placeholder="$t('common.selectPlaceholder')"
              @change="onRegisteredCityChange"
            >
              <lls-option
                v-for="item in registeredCityOptions"
                :key="item.code"
                :label="$i18n.locale === 'en' ? item.displayNameEn : item.displayName"
                :value="item.code"
              ></lls-option>
            </lls-select>
          </lls-form-item>
          <lls-form-item
            :label="$t('kycFile.basicsInfo.street')"
            prop="street"
            :rules="isChinaAddrRequired ? [{ required:true,message:$t('kycFile.basicsInfo.street'),trigger:['blur','change'] }]: [{}]"
          >
            <lls-input
              type="text"
              v-model="enterpriseInfo.street"
              clearable
              autocomplete="off"
              maxlength="180"
              :placeholder="$t('common.inputPlaceholder')"
            ></lls-input>
          </lls-form-item>
        </template>
        <template v-else>
          <!-- 注册地址 -->
          <lls-form-item :label="$t('kycFile.basicsInfo.regAddress')" prop="registeredDetail">
            <lls-input
              type="text"
              v-model="enterpriseInfo.registeredDetail"
              clearable
              autocomplete="off"
              maxlength="180"
              @change="regAddressChange"
              :placeholder="$t('common.inputPlaceholder')"
            ></lls-input>
          </lls-form-item>
        </template>
        
        <div class="item-check">
          <lls-checkbox v-model="isManageAddressSameAsRegistered" @change="changeEqua"></lls-checkbox>
          <div class="check-word"> {{ $t('kycFile.basicsInfo.regCountryTip') }}</div>
        </div>
        <lls-form-item :label="$t('kycFile.basicsInfo.opeCountry')" prop="manageCountryCode">
          <lls-select
            v-model="enterpriseInfo.manageCountryCode"
            filterable
            clearable
            @change="changeManageCountry"
            :placeholder="$t('common.selectPlaceholder')"
            :disabled="isManageAddressEditable"
          >
            <lls-option
              v-for="item in countryList"
              :key="item.id"
              :label="item.countryName"
              :value="item.countryCode"
            ></lls-option>
          </lls-select>
        </lls-form-item>
        <!-- 经营地址 -->
        <template v-if="showIndustryAndSizeOper">
          <lls-form-item
            :label="$t('kycFile.basicsInfo.operatingProvince')"
            prop="operationsProvinceCode"
            :rules="isChinaAddrRequired ? [{ required:true,message:$t('kycFile.basicsInfo.operatingProvince'),trigger:['blur','change'] }]: [{}]"
          >
            <lls-select
              v-model="enterpriseInfo.operationsProvinceCode"
              filterable
              clearable
              :placeholder="$t('common.selectPlaceholder')"
              @change="onManageProvinceChange"
            >
              <lls-option
                v-for="item in filteredManageProvinceOptions"
                :key="item.code"
                :label="$i18n.locale === 'en' ? item.displayNameEn : item.displayName"
                :value="item.code"
              ></lls-option>
            </lls-select>
          </lls-form-item>
          <lls-form-item
            :label="$t('kycFile.basicsInfo.operatingCity')"
            prop="operationsCityCode"
            :rules="isChinaAddrRequired ? [{ required:true,message:$t('kycFile.basicsInfo.operatingCity'),trigger:['blur','change'] }]: [{}]"
          >
            <lls-select
              v-model="enterpriseInfo.operationsCityCode"
              filterable
              clearable
              :placeholder="$t('common.selectPlaceholder')"
              @change="onManageCityChange"
            >
              <lls-option
                v-for="item in manageCityOptions"
                :key="item.code"
                :label="$i18n.locale === 'en' ? item.displayNameEn : item.displayName"
                :value="item.code"
              ></lls-option>
            </lls-select>
          </lls-form-item>
          <lls-form-item
            :label="$t('kycFile.basicsInfo.operatingStreet')"
            prop="operationsStreet"
            :rules="isChinaAddrRequired ? [{ required:true,message:$t('kycFile.basicsInfo.operatingStreet'),trigger:['blur','change'] }]: [{}]"
          >
            <lls-input
              type="text"
              v-model="enterpriseInfo.operationsStreet"
              clearable
              autocomplete="off"
              maxlength="180"
              :placeholder="$t('common.inputPlaceholder')"
            ></lls-input>
          </lls-form-item>
        </template>
        <template v-else>
          <lls-form-item :label="$t('kycFile.basicsInfo.opeAddress')" prop="manageDetail">
            <lls-input
              type="text"
              v-model="enterpriseInfo.manageDetail"
              clearable
              autocomplete="off"
              maxlength="180"
              :placeholder="$t('common.inputPlaceholder')"
              :disabled="isManageAddressEditable"
            ></lls-input>
          </lls-form-item>
        </template>
        <!-- 新增字段：所属行业（仅在中国/港澳台 & Supplier/Buyer & Merchants Financing&Account 时展示） -->
        <lls-form-item
          :label="$t('kycFile.basicsInfo.industry')"
          v-if="showIndustry"
          prop="industry"
          :rules="!isAccount ? [{ required:true,message:$t('kycFile.basicsInfo.industry'),trigger:['blur','change'] }]: [{}]"
        >
          <lls-select
            v-model="enterpriseInfo.industry"
            filterable
            clearable
            :placeholder="$t('common.selectPlaceholder')"
          >
            <lls-option
              v-for="item in industryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></lls-option>
          </lls-select>
        </lls-form-item>
        <!-- 新增字段：企业规模 -->
        <lls-form-item
          :label="$t('kycFile.basicsInfo.companySize')"
          v-if="showIndustryAndSize"
          :rules="!isAccount && isChina ? [{ required:true,message:$t('kycFile.basicsInfo.companySize'),trigger:['blur','change'] }]: [{}]"
        > 
          <lls-select
            v-model="enterpriseInfo.companySize"
            filterable
            clearable
            :placeholder="$t('common.selectPlaceholder')"
          >
            <lls-option
              v-for="item in companySizeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></lls-option>
          </lls-select>
        </lls-form-item>
      </div>
        <!-- 请上传营业执照或注册证书 -->
        <div class="com-word" v-if="enterpriseInfo.registeredAreaCode">
          <span class="require">*</span> 
          {{
          enterpriseInfo.registeredAreaCode == "CHN"
          ? $t('kycFile.basicsInfo.uploadBusinessLicense')
          : $t('kycFile.basicsInfo.uploadRegistrationCertificate')
          }}
        </div>
        <template v-if="enterpriseInfo.registeredAreaCode">
          <kycUpload
            v-if="enterpriseInfo.catgIdOne"
            :mediaId="enterpriseInfo.mediaId"
            :limit="1"
            modelCode="MKJ01ENT"
            :catgId="enterpriseInfo.catgIdOne"
            @toOcr="ocrEvent"
            style="margin-bottom:20px;"
          ></kycUpload>
        </template>
        <lls-form-item :label="$t('kycFile.basicsInfo.companyNameCn')" prop="companyNameCn">
          <lls-input
            type="text"
            v-model="enterpriseInfo.companyNameCn"
            clearable
            autocomplete="off"
            maxlength="200"
            :placeholder="$t('common.inputPlaceholder')"
          ></lls-input>
        </lls-form-item>
        <lls-form-item :label="$t('kycFile.basicsInfo.companyNameEn')" prop="companyName">
          <lls-input
            type="text"
            v-model="enterpriseInfo.companyName"
            clearable
            autocomplete="off"
            maxlength="140"
            :placeholder="$t('common.inputPlaceholder')"
          ></lls-input>
        </lls-form-item>
        <div class="lable-mr0" v-if="isCompanyTypeVisible">
          <lls-form-item :label="$t('kycFile.basicsInfo.companyType')" prop="companyType">
            <lls-radio-group v-model="enterpriseInfo.companyType">
              <lls-radio label="GENERAL_TAXPAYER">
                <!-- 一般纳税人 -->
                {{ $t("kycFile.basicsInfo.companyTypeItem1") }}
              </lls-radio>
              <lls-radio label="SMALL_SCALE">
                <!-- 小规模企业 -->
                {{ $t("kycFile.basicsInfo.companyTypeItem2") }}
              </lls-radio>
            </lls-radio-group>
          </lls-form-item>
        </div>
        <!-- 企业证件编号 -->
        <!-- 当 客户选择  Registered address country  = HONGKONG；Company docs no. 改成 UBI
             客户端会新增一个 “指引截图” -->
          <lls-form-item 
            :label="enterpriseInfo.registeredAreaCode === 'HKG' ? 'UBI' : $t('kycFile.basicsInfo.companyCode')" 
            prop="companyIdentCode">
          <lls-image-viewer v-if="showImageViewer" :urlList="urls" :on-close="handleClose" :exterActions="['rename', 'download', 'replace']"></lls-image-viewer>
          <div v-if="enterpriseInfo.registeredAreaCode === 'HKG'" class="code-icon">
            {{ $t('common.sample') }}：
            <div :class="$i18n.locale === 'en' ? 'code-en' : 'code-zh'" @click="show">
            </div>
          </div>

          <lls-input
            type="text"
            v-model="enterpriseInfo.companyIdentCode"
            clearable
            autocomplete="off"
            :maxlength="inputNumLimit(enterpriseInfo.registeredAreaCode)"
            :placeholder="enterpriseInfo.registeredAreaCode === 'HKG' ? $t('common.companyIdentCodePlaceholder') : $t('common.inputPlaceholder')"
          ></lls-input>
        </lls-form-item>
        <!-- 境外企业时，布局需要 -->
        <div style="width:320px;" v-if="!isCompanyTypeVisible"></div>
        <lls-form-item
          :label="$t('kycFile.basicsInfo.companyStartDate')"
          prop="companyIdentStartTime"
        >
          <lls-date-picker
            :editable="true"
            v-model="enterpriseInfo.companyIdentStartTime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :placeholder="$t('common.startPlaceholder')"
          ></lls-date-picker>
        </lls-form-item>
        <lls-form-item
          :label="$t('kycFile.basicsInfo.companyEndDate')"
          prop="companyIdentExpirationTime"
        >
          <div class="change-long-term" :class="$i18n.locale === 'en' ? 'en-term' : 'zh-term'">
            <lls-checkbox v-model="longTermEffective" @change="changeLongTerm"></lls-checkbox>
            <div
              class="term-word"
              style="margin-left: 8px;"
            >
            {{ $t('kycFile.basicsInfo.companyDateEver') }}
            </div>
          </div>

          <lls-date-picker
            :editable="true"
            :disabled="dateDisabled"
            v-model="enterpriseInfo.companyIdentExpirationTime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :placeholder="$t('common.endPlaceholder')"
          ></lls-date-picker>
        </lls-form-item>
        <!-- 企业证件签发地 -->
        <lls-form-item
          :label="$t('kycFile.basicsInfo.issuedPlaceOfCertificate')"
          prop="certIssueCode"
        >
          <lls-select
            v-model="enterpriseInfo.certIssueCode"
            filterable
            clearable
            :placeholder="$t('common.selectPlaceholder')"
          >
            <lls-option
              v-for="item in countryList"
              :key="item.id"
              :label="item.countryName"
              :value="item.countryCode"
            ></lls-option>
          </lls-select>
        </lls-form-item>
        <div class="com-word" style="width:720px;"><span class="require">*</span>{{$t('kycFile.basicsInfo.equityFile')}}</div>
        <template>
          <kycUpload
            v-if="enterpriseInfo.equityId"
            :mediaId="enterpriseInfo.mediaId"
            modelCode="MKJ01ENT"
            :catgId="enterpriseInfo.equityId"
            :limit="5"
            style="margin-bottom:20px;"
          ></kycUpload>
        </template>
        <div class="com-word" style="width:720px;">{{$t('kycFile.basicsInfo.constitutionFile')}}</div>
        <template>
          <kycUpload
            v-if="enterpriseInfo.constitutionId"
            :mediaId="enterpriseInfo.mediaId"
            modelCode="MKJ01ENT"
            :catgId="enterpriseInfo.constitutionId"
            :limit="5"
            style="margin-bottom:20px;"
          ></kycUpload>
        </template>
        <div  v-if="enterpriseInfo.bussinessId && enterpriseInfo.registeredAreaCode !== 'CHN'" class="com-word" style="width:720px;" ><span class="require" v-if="enterpriseInfo.registeredAreaCode === 'HKG'">*</span>{{$t('kycFile.basicsInfo.businessFile')}}</div>
        <template>
          <kycUpload
            v-if="enterpriseInfo.bussinessId && enterpriseInfo.registeredAreaCode !== 'CHN'"
            :mediaId="enterpriseInfo.mediaId"
            modelCode="MKJ01ENT"
            :catgId="enterpriseInfo.bussinessId"
            :limit="5"
            style="margin-bottom:20px;"
            ref="businessFile"
          ></kycUpload>
        </template>
        <div class="com-word" style="width:720px;">{{$t('kycFile.basicsInfo.financialFile')}}</div>
        <template>
          <kycUpload
            v-if="enterpriseInfo.financialId"
            :mediaId="enterpriseInfo.mediaId"
            modelCode="MKJ01ENT"
            :catgId="enterpriseInfo.financialId"
            :limit="5"
            style="margin-bottom:20px;"
          ></kycUpload>
        </template>
        <div class="com-word" style="width:720px;">{{$t('kycFile.basicsInfo.saleFile')}}</div>
        <template>
          <kycUpload
            v-if="enterpriseInfo.saleId"
            :mediaId="enterpriseInfo.mediaId"
            modelCode="MKJ01ENT"
            :catgId="enterpriseInfo.saleId"
            :limit="5"
            style="margin-bottom:20px;"
          ></kycUpload>
        </template>
        <div class="com-word" style="width:720px;" v-if="enterpriseInfo.registeredAreaCode === 'HKG'"><span class="require">*</span>{{$t('kycFile.basicsInfo.annualReport')}}</div>
        <template v-if="enterpriseInfo.registeredAreaCode === 'HKG'">
          <kycUpload
           ref="annualReportRef"
            v-if="enterpriseInfo.annualReportId"
            :mediaId="enterpriseInfo.mediaId"
            modelCode="MKJ01ENT"
            :catgId="enterpriseInfo.annualReportId"
            :limit="5"
            style="margin-bottom:20px;"
          ></kycUpload>
        </template>
        <div class="com-word" style="width:720px;">{{$t('kycFile.basicsInfo.otherEnterpriseFile')}}</div>
        <template>
          <kycUpload
            v-if="enterpriseInfo.otherEnterpriseId"
            :mediaId="enterpriseInfo.mediaId"
            modelCode="MKJ01ENT"
            :catgId="enterpriseInfo.otherEnterpriseId"
            :limit="5"
            style="margin-bottom:20px;"
          ></kycUpload>
        </template>
      </lls-form>
    </div>
  </div>
</template>
<script>
import kycUpload from './kycUpload.vue';
import ImageViewer from '@linklogis/image-viewer';
import systemAPI from '@/api/projAPI/system';
export default {
  name: 'basicsInfo',
  components: {
    kycUpload,
    llsImageViewer: ImageViewer
  },
  data() {
    let validateCompanyName = (rule, value, callback) => {
      let regCompanyName = new RegExp('^[a-zA-Z0-9-/?:().,+ ]{4,}$')
      if (value === '') {
        callback(new Error(this.$t('kycFile.basicsInfo.companyNameEn')))
      } else if (!regCompanyName.test(value)) {
        callback(new Error(this.$t('kycFile.basicsInfo.companyNameEnTip')))
      } else {
        callback()
      }
    }
    let validateCompanyIdentCode = (rule, value, callback) => {
      let regCompanyIdentCode = new RegExp("^[a-zA-Z0-9-/?:().,'+ ]+$")
      if (value === '') {
        callback(new Error(this.$t('kycFile.basicsInfo.companyCode')))
      } else if (this.enterpriseInfo.registeredAreaCode === 'HKG' && value.length < 8) {
        callback(new Error(this.$t('kycFile.basicsInfo.atLeastEightchar')))
      } else if (this.enterpriseInfo.registeredAreaCode === 'CHN' && value.length !== 18) {
        callback(new Error(this.$t('kycFile.basicsInfo.requireEighteenChar')))
      } else if (!regCompanyIdentCode.test(value)) {
        callback(new Error(this.$t('kycFile.basicsInfo.companyCodeTip')))
      } else {
        callback()
      }
    }
    let validateRegisteredDetail = (rule, value, callback) => {
      let regRegisteredDetail = new RegExp("^[a-zA-Z0-9-/?:().,'+ \s\u4e00-\u9fa5]+$");
      if (value === '') {
        callback(new Error(this.$t('kycFile.basicsInfo.regAddress')))
      } else if (!regRegisteredDetail.test(value)) {
        callback(new Error(this.$t('kycFile.basicsInfo.regAddressTip')))
      } else {
        callback()
      }
    }
    let validateManageDetail = (rule, value, callback) => {
      let regManageDetail = new RegExp("^[a-zA-Z0-9-/?:().,'+ \s\u4e00-\u9fa5]+$");
      if (value === '') {
        callback(new Error(this.$t('kycFile.basicsInfo.opeAddress')))
      } else if (!regManageDetail.test(value)) {
        callback(new Error(this.$t('kycFile.basicsInfo.opeAddressTip')))
      } else {
        callback()
      }
    }
    let validateOperationsCityCode = (rule, value, callback) => {
      if (this.isChinaAddrRequired && (!value || value === '')) {
        callback(new Error(this.$t('kycFile.basicsInfo.operatingCity')))
      } else {
        callback()
      }
    }
    let validateOperationsStreet = (rule, value, callback) => {
      if (this.isChinaAddrRequired && (!value || value === '')) {
        callback(new Error(this.$t('kycFile.basicsInfo.operatingStreet')))
      } else {
        callback()
      }
    }
    return {
      showImageViewer: false,
      urls: [
        {
          url: this.$i18n.locale === 'en'? require('@/static/kjaccSonImg/codeEn.png') : require('@/static/kjaccSonImg/codeZh.png'),
          title: 'code.png'
        }
      ],
      countryList: [],
      sonLoading: false,
      enterpriseId: sessionStorage.getItem('enterpriseId'),
      enterpriseInfo: {
        // 新增字段：所属行业 & 企业规模
        industry: null,
        companySize: null,
        // 新增字段：注册地址 省市(代码)+街道
        cityCode: null,
        city: null,
        street: null,
        // 新增字段：经营地址 省市(代码)+街道
        operationsCityCode: '',
        operationsCity: null,
        operationsStreet: '',
        // 省份拆分字段
        provinceCode: null,
        province: null,
        operationsProvinceCode: null,
        operationsProvince: null,
        registeredArea: null,
        registeredAreaCode: null,
        registeredDetail: null,
        companyNameCn: null,
        companyName: null,
        manageCountry: null,
        manageCountryCode: null,
        manageDetail: null,
        catgIdOne: null,
        companyType: null,
        companyIdentCode: null,
        companyIdentStartTime: null,
        companyIdentExpirationTime: null,
        companyIdentTime: [],
        expirationPerennial: null,
        companyIdentType: null,
        companyOtherIdentType: null,
        certIssueCode: null,
        id: sessionStorage.getItem('enterpriseId'),
        manageDetailIsRegisteredDetail: 'N',
        equityId: 'CENT004',
        bussinessId: 'CENT001',
        financialId: 'CENT008',
        saleId: 'CENT009',
        otherEnterpriseId: 'CENT011',
        constitutionId: 'CENT010',
        annualReportId: 'CENT019',
        mediaId: sessionStorage.getItem('enterpriseId'),
        productType: ''
      },
      isManageAddressSameAsRegistered: false,
      isManageAddressEditable: false,
      longTermEffective: false,
      isCompanyTypeVisible: false,
      rules: {
          registeredAreaCode: [
            { required: true, message: this.$t('kycFile.basicsInfo.regCountry'), trigger: 'change' }
          ],
          registeredDetail: [
            { required: true, message: this.$t('kycFile.basicsInfo.regAddress'), trigger: ['change', 'blur'] },
            { validator: validateRegisteredDetail, trigger: ['change', 'blur'] },
          ],
          manageCountryCode: [
            { required: true, message: this.$t('kycFile.basicsInfo.opeCountry'), trigger: 'change' }
          ],
          manageDetail: [
            { required: true, message: this.$t('kycFile.basicsInfo.opeAddress'), trigger: ['change', 'blur'] },
            { validator: validateManageDetail, trigger: ['change', 'blur'] },
          ],
          companyNameCn: [
            { required: true, message: this.$t('kycFile.basicsInfo.companyNameCn'), trigger: ['change', 'blur'] },
          ],
          companyName: [
            { required: true, message: this.$t('kycFile.basicsInfo.companyNameEn'), trigger: ['change', 'blur'] },
            { validator: validateCompanyName, trigger: ['change', 'blur'] },
          ],
          companyIdentCode: [
            { required: true, message: this.$t('kycFile.basicsInfo.companyCode'), trigger: ['change', 'blur'] },
            { validator: validateCompanyIdentCode, trigger: ['change', 'blur'] },
          ],
          companyIdentStartTime: [
            { required: true, message: this.$t('kycFile.basicsInfo.companyStartDate'), trigger: 'change' },
          ],
          companyIdentExpirationTime: [
            { required: true, message: this.$t('kycFile.basicsInfo.companyEndDate'), trigger: 'change' },
          ],
          certIssueCode: [
            { required: true, message: this.$t('kycFile.basicsInfo.issuedPlaceOfCertificate'), trigger: 'change' },
          ],
          operationsCityCode: [
            { validator: validateOperationsCityCode, trigger: ['blur', 'change'] },
          ],
          operationsStreet: [
            { validator: validateOperationsStreet, trigger: ['blur', 'change'] },
          ],
        },
      dateDisabled: false,
      companyOtherIdentTypeArr: [],
      // 所属行业枚举
      industryOptions: [],
      // 企业规模枚举
      companySizeOptions: [],
      // 省市级联数据（用于中国/港澳台地址）
      cityListForAddr: [],
      // 存储所有省份数据（用于过滤）
      allProvinceOptions: []
    };
  },
  computed: {
    // 角色（从企业信息里取枚举 code）
    enterpriseRole() {
      return this.enterpriseInfo.enterpriseRole
    },
    // 经营国家是否中国/港澳台
    isChinaRegionOper() {
      const code = this.enterpriseInfo.manageCountryCode
      const chinaCodes = ['CHN', 'HKG', 'MAC', 'TWN']
      return chinaCodes.includes(code)
    },
    // 注册国家是否中国/港澳台
    isChinaRegion() {
      const code = this.enterpriseInfo.registeredAreaCode
      const chinaCodes = ['CHN', 'HKG', 'MAC', 'TWN']
      return chinaCodes.includes(code)
    },
    isChina() {
      const code = this.enterpriseInfo.registeredAreaCode
      return code === 'CHN'
    },
    isAccount(){
      return this.$route.query.productType === 'ACCOUNT'
    },
    isEfinance(){
      return ['E_FINANCE','DEFAULT_PRODUCT'].includes(this.$route.query.productType)
    },
    showIndustry() {
      return (
        this.isEfinance || 
        (
          this.isChinaRegion && this.isAccount
        )
      )
    },
    // 是否展示所属行业 & 企业规模
    showIndustryAndSize() {
      return (
        (
          this.isChinaRegion &&
          this.isEfinance
        ) || (
          this.isChinaRegion && this.isAccount
        )
      )
    },
    showIndustryAndSizeOper() {
      return (
        (
          this.isChinaRegionOper &&
          this.isEfinance
        ) || (
          this.isChinaRegionOper && this.isAccount
        )
      )
    },
    // 中国地区下，Supplier 时地址是否必填（Province/City + Street）
    isChinaAddrRequired() {
      return this.isEfinance || this.isAccount
    },
    // 注册地址-省份下拉，根据注册国家过滤（中国/港澳台）
    filteredRegisteredProvinceOptions() {
      const countryCode = this.enterpriseInfo.registeredAreaCode
      if (!countryCode) return []
      const chinaCodes = ['CHN', 'HKG', 'MAC', 'TWN']
      if (!chinaCodes.includes(countryCode)) return []
      // 根据国家代码过滤省份
      return this.filterProvincesByCountry(countryCode)
    },
    // 经营地址-省份下拉，根据经营国家过滤（中国/港澳台）
    filteredManageProvinceOptions() {
      const countryCode = this.enterpriseInfo.manageCountryCode
      if (!countryCode) return []
      const chinaCodes = ['CHN', 'HKG', 'MAC', 'TWN']
      if (!chinaCodes.includes(countryCode)) return []
      // 根据国家代码过滤省份
      return this.filterProvincesByCountry(countryCode)
    },
    // 注册地址-城市下拉，根据所选省份过滤
    registeredCityOptions() {
      const provinceCode = this.enterpriseInfo.provinceCode
      if (!provinceCode) return []
      const list = this.cityListForAddr || []
      const cities =
        list.filter(
          (item) =>
            item.parentCode === provinceCode
        )
      return cities.map((c) => {
        return {
          code: c.code || '',
          name: c.name || '',
          displayName:c.displayName || '',
          displayNameEn:c.displayNameEn || ''
        }
      })
    },
    // 经营地址-城市下拉，根据所选省份过滤
    manageCityOptions() {
      const provinceCode = this.enterpriseInfo.operationsProvinceCode
      if (!provinceCode) return []
      const list = this.cityListForAddr || []
      const cities =
        list.filter(
          (item) =>
           item.parentCode === provinceCode
        )
      return cities.map((c) => {
        return {
          code: c.code || '',
          name: c.name || '',
          displayName:c.displayName || '',
          displayNameEn:c.displayNameEn || ''
        }
      })
    },
    inputNumLimit(){
      return (registeredAreaCode)=>{
        let num = 0
        switch(registeredAreaCode){
          case "CHN":
            num = 18
            break
          default:
            num = 50
            break
        }
        return num
      }
    },
    enterpriseObj() {
      const storedData = sessionStorage.getItem('企业其他文件类型kj.kyc.EnterpriseOtherIdentTypeEnum');
      return storedData? JSON.parse(storedData) : [];
    }
  },
  mounted() {
    this.initPage();
    this.getBaseInfoOptions()
  },
  methods: {
    async getBaseInfoOptions() {
      // 行业及公司规模
      const { data } = await systemAPI.queryList({ enumType:'ZhongdengIndustryEnum' });
      this.industryOptions = data?.data || [];
      const { data:data2 } = await systemAPI.queryList({ enumType:'ZhongdengCompanySizeEnum' });
      this.companySizeOptions = data2?.data || [];

      // 省市枚举
      const {data:data3} = await systemAPI.getCity()
      this.cityListForAddr = data3?.data || [];
      const {data:data4} = await systemAPI.getProvince()
      this.allProvinceOptions = data4?.data || [];
      
      // 省市数据加载完成后，同步省市名称
      this.$nextTick(() => {
        this.syncProvinceAndCityNames();
      });
    },
     // 注册地址-省份变化时，清空城市
     onRegisteredProvinceChange() {
      // 同步省份名称
      if (this.enterpriseInfo.provinceCode) {
        const provinceList = this.filteredRegisteredProvinceOptions;
        const province = provinceList.find(item => item.code === this.enterpriseInfo.provinceCode);
        this.enterpriseInfo.province = province ? province.displayNameEn : null;
      } else {
        this.enterpriseInfo.province = null;
      }
      // 清空城市
      this.enterpriseInfo.cityCode = null;
      this.enterpriseInfo.city = null;
    },
    // 注册地址-城市变化时，同步城市名称
    onRegisteredCityChange() {
      if (this.enterpriseInfo.cityCode) {
        const city = this.registeredCityOptions.find(item => item.code === this.enterpriseInfo.cityCode);
        this.enterpriseInfo.city = city ? city.displayNameEn : null;
      } else {
        this.enterpriseInfo.city = null;
      }
    },
    // 经营地址-省份变化时，清空城市
    onManageProvinceChange() {
      // 同步经营省份名称
      if (this.enterpriseInfo.operationsProvinceCode) {
        const provinceList = this.filteredManageProvinceOptions;
        const province = provinceList.find(item => item.code === this.enterpriseInfo.operationsProvinceCode);
        this.enterpriseInfo.operationsProvince = province ? province.displayNameEn : null;
      } else {
        this.enterpriseInfo.operationsProvince = null;
      }
      // 清空经营城市
      this.enterpriseInfo.operationsCityCode = null;
      this.enterpriseInfo.operationsCity = null;
    },
    // 经营地址-城市变化时，同步城市名称
    onManageCityChange() {
      if (this.enterpriseInfo.operationsCityCode) {
        const city = this.manageCityOptions.find(item => item.code === this.enterpriseInfo.operationsCityCode);
        this.enterpriseInfo.operationsCity = city ? city.displayNameEn : null;
      } else {
        this.enterpriseInfo.operationsCity = null;
      }
    },
    show() {
      this.showImageViewer = true;
    },
    handleClose() {
      this.showImageViewer = false;
    },
    // 页面初始化
    async initPage() {
      await this.getCountry();
      await this.getEnterprise();
    },
    // 进入页面查询企业信息
    async getEnterprise() {
      this.sonLoading = true;
      try {
        const { data } = await this.$API.kycFile.getEnterprise(this.enterpriseId);
        if (data?.data) {
          const tl = this.filterObjectDict(data?.data);
          tl.productType = this.$route.query.productType
          tl.companyIdentTime = tl.companyIdentStartTime? [tl.companyIdentStartTime, tl.companyIdentExpirationTime || ''] : [];
          this.longTermEffective = tl.expirationPerennial === 'Y';
          this.dateDisabled = this.longTermEffective;
          this.enterpriseInfo.companyIdentExpirationTime = this.longTermEffective? '9999-12-31' : null;
          this.isManageAddressSameAsRegistered = tl.manageDetailIsRegisteredDetail === 'Y';
          this.isManageAddressEditable = this.isManageAddressSameAsRegistered;
          const catgIdOneValue = tl.registeredAreaCode === 'CHN'? 'CENT005' : 'CENT002';
          const isCompanyTypeVisibleValue = tl.registeredAreaCode === 'CHN';
          this.enterpriseInfo.catgIdOne = catgIdOneValue;
          this.isCompanyTypeVisible = isCompanyTypeVisibleValue;
          this.companyOtherIdentTypeArr = isCompanyTypeVisibleValue
           ? this.enterpriseObj.filter(item => item['dictParam']!== 'BUSINESS_REGISTER_CERTIFICATE')
            : this.enterpriseObj;
          if(tl.productId) {
          delete(tl.productId)
          }
          this.enterpriseInfo = Object.assign({}, this.enterpriseInfo, tl)
          // 数据加载完成后，同步省市名称
          this.$nextTick(() => {
            this.syncProvinceAndCityNames();
          });
        }
      } catch (error) {
      } finally {
        this.sonLoading = false;
      }
    },
    // 同步省市名称（用于数据加载后或数据变更时）
    syncProvinceAndCityNames() {
      // 同步注册地址省份名称
      if (this.enterpriseInfo.provinceCode && this.allProvinceOptions.length > 0) {
        const province = this.allProvinceOptions.find(item => item.code === this.enterpriseInfo.provinceCode);
        this.enterpriseInfo.province = province ? province.displayNameEn : null;
      }
      // 同步注册地址城市名称
      if (this.enterpriseInfo.cityCode && this.registeredCityOptions.length > 0) {
        const city = this.registeredCityOptions.find(item => item.code === this.enterpriseInfo.cityCode);
        this.enterpriseInfo.city = city ? city.displayNameEn : null;
      }
      // 同步经营地址省份名称
      if (this.enterpriseInfo.operationsProvinceCode && this.allProvinceOptions.length > 0) {
        const province = this.allProvinceOptions.find(item => item.code === this.enterpriseInfo.operationsProvinceCode);
        this.enterpriseInfo.operationsProvince = province ? province.displayNameEn : null;
      }
      // 同步经营地址城市名称
      if (this.enterpriseInfo.operationsCityCode && this.manageCityOptions.length > 0) {
        const city = this.manageCityOptions.find(item => item.code === this.enterpriseInfo.operationsCityCode);
        this.enterpriseInfo.operationsCity = city ? city.displayNameEn : null;
        this.enterpriseInfo.manageCity = city ? city.displayNameEn : null;
      }
    },
    // 查询国家表
    async getCountry() {
      this.sonLoading = true;
      try {
        const { data } = await this.$API.kycFile.getCountry({});
        this.countryList = data?.data || [];
      } catch (error) {
      } finally {
        this.sonLoading = false;
      }
    },
    changeEqua(val) {
      this.enterpriseInfo.manageCountry = val? this.enterpriseInfo.registeredArea : null;
      this.enterpriseInfo.manageCountryCode = val? this.enterpriseInfo.registeredAreaCode : null;
      this.enterpriseInfo.manageDetail = val? this.enterpriseInfo.registeredDetail : null;
      this.enterpriseInfo.manageDetailIsRegisteredDetail = val? 'Y' : 'N';
      this.isManageAddressEditable = val;
      
      // 如果注册地址显示省市街道（isChinaRegion为true），且勾选了"经营地址与注册地址一致"
      // 则复制注册地址的省市街道到经营地址
      if (val && this.isChinaRegion) {
        // 复制省份代码和名称
        this.enterpriseInfo.operationsProvinceCode = this.enterpriseInfo.provinceCode;
        this.enterpriseInfo.operationsProvince = this.enterpriseInfo.province;
        // 复制城市代码和名称
        this.enterpriseInfo.operationsCityCode = this.enterpriseInfo.cityCode;
        this.enterpriseInfo.operationsCity = this.enterpriseInfo.city;
        // 复制街道
        this.enterpriseInfo.operationsStreet = this.enterpriseInfo.street;
      } else if (!val) {
        // 取消勾选时，清空经营地址的省市街道
        this.enterpriseInfo.operationsProvinceCode = null;
        this.enterpriseInfo.operationsProvince = null;
        this.enterpriseInfo.operationsCityCode = null;
        this.enterpriseInfo.operationsCity = null;
        this.enterpriseInfo.operationsStreet = '';
      }
    },
    changeLongTerm(val) {
      this.dateDisabled = val;
      this.longTermEffective = val;
      this.enterpriseInfo.expirationPerennial = val? 'Y' : 'N';
      this.enterpriseInfo.companyIdentExpirationTime = val? '9999-12-31' : null;
    },
    async changeRegArea(val) {
      if (this.enterpriseInfo.manageCountryCode && val!== this.enterpriseInfo.manageCountryCode) {
        this.enterpriseInfo.manageDetailIsRegisteredDetail = 'N';
        this.isManageAddressSameAsRegistered = false;
        this.isManageAddressEditable = false;
      }
      //when select HKG or CHN, validate the companyIndentCode
      if(["CHN","HKG"].includes(val)){
        this.$refs['ruleForm'].validateField(['companyIdentCode'])
      }
      const catgIdOneValue = val === 'CHN'? 'CENT005' : 'CENT002';
      const isCompanyTypeVisibleValue = val === 'CHN';
      this.enterpriseInfo.catgIdOne = catgIdOneValue;
      this.isCompanyTypeVisible = isCompanyTypeVisibleValue;
      this.companyOtherIdentTypeArr = isCompanyTypeVisibleValue
       ? this.enterpriseObj.filter(item => item['dictParam']!== 'BUSINESS_REGISTER_CERTIFICATE')
        : this.enterpriseObj;
      const country = this.countryList.find(item => item.countryCode === val);
      this.enterpriseInfo.registeredArea = country?.countryNameEng || null;
      
      // 当注册国家变更时，清空对应的地址字段
      const chinaCodes = ['CHN', 'HKG', 'MAC', 'TWN']
      if (chinaCodes.includes(val)) {
        // 如果是中国/港澳台，清空省市街道字段
        this.enterpriseInfo.provinceCode = null
        this.enterpriseInfo.province = null
        this.enterpriseInfo.cityCode = null
        this.enterpriseInfo.city = null
        this.enterpriseInfo.street = null
      } else {
        // 如果不是中国/港澳台，清空原地址字段
        this.enterpriseInfo.registeredDetail = null
      }
    },
    regAddressChange(val) {
      if (this.enterpriseInfo.registeredDetail && val!== this.enterpriseInfo.manageDetail) {
        this.enterpriseInfo.manageDetailIsRegisteredDetail = 'N';
        this.isManageAddressSameAsRegistered = false;
        this.isManageAddressEditable = false;
      }
    },
    changeManageCountry(val) {
      const country = this.countryList.find(item => item.countryCode === val);
      this.enterpriseInfo.manageCountry = country?.countryNameEng || null;
      
      // 当经营国家变更时，清空对应的地址字段
      const chinaCodes = ['CHN', 'HKG', 'MAC', 'TWN']
      if (chinaCodes.includes(val)) {
        // 如果是中国/港澳台，清空省市街道字段
        this.enterpriseInfo.operationsProvinceCode = null
        this.enterpriseInfo.operationsProvince = null
        this.enterpriseInfo.operationsCityCode = null
        this.enterpriseInfo.operationsCity = null
        this.enterpriseInfo.operationsStreet = null
      } else {
        // 如果不是中国/港澳台，清空原地址字段
        this.enterpriseInfo.manageDetail = null
      }
    },
    // 根据国家代码过滤省份列表
    filterProvincesByCountry(countryCode) {
      if (!this.allProvinceOptions || this.allProvinceOptions.length === 0) {
        return []
      }
      
      // 如果省份数据包含countryCode字段，直接过滤
      if (this.allProvinceOptions[0] && this.allProvinceOptions[0].countryCode !== undefined) {
        return this.allProvinceOptions.filter(item => item.countryCode === countryCode)
      }
      
      return this.allProvinceOptions
    },
    // 接收 ocr 返回的数据
    ocrEvent(obj) {
      this.enterpriseInfo.companyNameCn = obj?.biz_license_company_name || '';
      this.enterpriseInfo.companyIdentCode = obj?.biz_license_credit_code || '';
    },
    async nextSon() {
      const isValid = await this.$refs['ruleForm'].validate();
      if (!isValid) return;
      if(this.enterpriseInfo.registeredAreaCode === 'HKG' && !this.$refs.annualReportRef?.fileList.length) {
        this.$message({
          message: this.$t('exportDrawbackKyc.annualReportTip'),
          type: 'warning'
        })
        return
      }
      if(this.enterpriseInfo.registeredAreaCode === 'HKG' && !this.$refs.businessFile?.fileList.length) {
        this.$message({
          message: this.$t('kycFile.basicsInfo.businessFile'),
          type: 'warning'
        })
        return
      }
        this.sonLoading = true;
        this.enterpriseInfo.industry = this.enterpriseInfo.industry || null;
        this.enterpriseInfo.companySize = this.enterpriseInfo.companySize || null;
        if(this.enterpriseInfo.operationsCity || this.enterpriseInfo.operationsProvince || this.enterpriseInfo.operationsStreet) {
          this.enterpriseInfo['manageDetail'] = (this.enterpriseInfo.operationsProvince || '') + (this.enterpriseInfo.operationsCity || '') + (this.enterpriseInfo.operationsStreet || '')
        }
        if(this.enterpriseInfo.province || this.enterpriseInfo.city || this.enterpriseInfo.street) {
          this.enterpriseInfo['registeredDetail'] = (this.enterpriseInfo.province || '') + (this.enterpriseInfo.city || '') + (this.enterpriseInfo.street || '')
        }
        try {
          const {data} = await this.$API.kycFile.saveEnterprise(this.enterpriseInfo);
          if (data?.code === '200') {
            let tl = data?.data || {};
            tl = this.filterObjectDict(tl);
            sessionStorage.setItem('location', tl.location);
            this.$emit('toNext')
          } else {
            this.$message.error(data.message);
          }
        } catch (error) {
        } finally {
          this.sonLoading = false;
        }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../kycCommon.scss';
.basicsInfo {
  width: 100%;
  height: 100%;
  white-space: normal;
  .info-center {
    width: 720px;
    margin: 0 auto;
    .kyc-icon {
      width: 44px;
      height: 44px;
      background: url('~@/static/kjaccSonImg/kycIcon.png') center center
        no-repeat;
      margin: 0 auto;
    }
    .title {
      color: rgba(46, 90, 153, 1);
      text-align: center;
      padding: 14px 0 26px 0;
      line-height: 24px;
      font-weight: 600;
      font-size: 20px;
    }
    .sub-title {
      font-size: 12px;
    }
    .com-word {
      font-size: 14px;
      line-height: 20px;
      color: #333333;
      margin-bottom: 10px;
    }
    .item-check {
      width: 720px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 15px;
      .check-word {
        font-size: 14px;
        line-height: 20px;
        color: #333333;
        margin-left: 8px;
        margin-top: 1px;
      }
    }
    .require{
      display: inline-block;
      color: #ff4c65;
      font-size: 12px;
      font-weight: normal;
      margin-right: 3px;
    }
    .requ-red {
      position: absolute;
      top: -32px;
      left: 0px;
      color: #ff4c65;
    }
    .bg-item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      background: rgba(247, 251, 255, 1);
      padding: 12px 20px;
      margin: 20px 0;
    }
    ::v-deep .lls-form-item__label {
      margin-left: 9px;
    }
    ::v-deep .lls-form-item {
      margin-bottom: 16px;
    }
    .lable-mr0 ::v-deep .lls-form-item__label {
      margin-left: 0px;
    }
    .long-term {
      width: 320px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 28px;
      .term-word {
        font-size: 14px;
        line-height: 20px;
        color: #333333;
        margin-left: 8px;
        margin-top: 1px;
      }
    }
  }
  .code-icon {
    position: absolute;
    left: 401px;
    bottom: -7px;
    display: flex;
    white-space: nowrap;
  }
  .code-en {
    width: 55px;
    height: 64px;
    background: url('~@/static/kjaccSonImg/codeEn.png') center center no-repeat;
    background-size: contain;
  }
  .code-zh {
    width: 55px;
    height: 64px;
    background: url('~@/static/kjaccSonImg/codeZh.png') center center no-repeat;
    background-size: contain;
  }
  .change-long-term {
    top: -32px;
    display: flex;
    position: absolute;
  }
  .zh-term {
    right: 0;
  }
  .en-term {
    right: -35px;
  }
}
</style>
